import React from "react";
import OftadehAppBar from "../../components/OftadehAppBar/OftadehAppBar";

const Header = () => <OftadehAppBar drawerWidth={240} />;

export default Header;
